<template>
  <div>
    <div
      class="page_container goodsManageSet"
      v-loading="loading"
      element-loading-text="请稍后"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <div class="breadcrumb flex-rowl">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/manage' }"
            >SKU管理</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/commondityIndex/cManageIndex' }"
            >商品管理</el-breadcrumb-item
          >
          <el-breadcrumb-item>其它设置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="form_container">
        <h1>其它设置</h1>
        <div class="content_wrap">
          <div class="form_wrap">
            <div class="form_item">
              
            </div>
            <div class="block">
              <p>是否设置为精品推荐</p>
              <div class="radio_box">
                <el-radio-group v-model="formData.isintro">
                  <el-radio label="是">是</el-radio>
                  <el-radio label="否">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="block">
              <p>是否设置为置顶</p>
              <div class="radio_box">
                <el-radio-group v-model="formData.istop">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="block">
              <p>是否设置为预售</p>
              <div class="radio_box" style="margin-bottom: 10px">
                <el-radio-group v-model="formData.ispre">
                  <el-radio :label="true">是</el-radio>
                  <el-radio :label="false">否</el-radio>
                </el-radio-group>
              </div>

              <div class="input_box" v-if="formData.ispre">
                <!-- <el-input
                  v-model="formData.limitnum"
                  placeholder="请输入每位用户限购数量"
                  maxlength="2"
                  type="digit"
                /> -->
                <el-date-picker
                  v-model="formData.predate"
                  type="date"
                  placeholder="请选择开售时间"
                >
                </el-date-picker>
              </div>
            </div>

            <div class="block">
              <p>前端购买人数显示管理</p>
              <div class="radio_box" style="margin-bottom: 10px">
                <el-radio-group v-model="formData.numtype" class="flex-rowl">
                  <el-radio label="显示真实成交数">显示真实成交数</el-radio>
                  <el-radio label="显示静态数字">显示静态数字</el-radio>
                </el-radio-group>
              </div>
              <div class="input_box" v-if="formData.numtype == '显示静态数字'">
                <el-input
                  v-model="formData.numview"
                  placeholder="请输入购买人数"
                  maxlength="6"
                  type="digit"
                />
              </div>
            </div>

            <div class="block">
              <p>设置关联商品</p>
              <p class="red" style="margin-bottom: 0.25rem">
                输入已知商品ID，最多关联6件
              </p>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid1"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid2"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid3"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid4"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid5"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.cmid6"
                  placeholder="请输入管理商品ID"
                  maxlength="15"
                ></el-input>
              </div>
            </div>

            <div class="block">
              <p>设置关联盲盒</p>
              <p class="red" style="margin-bottom: 0.25rem">
                输入已知盲盒ID，最多关联6件
              </p>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid1"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid2"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid3"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid4"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid5"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
              <div class="input_box">
                <el-input
                  type="number"
                  v-model="formData.boxid6"
                  placeholder="请输入关联盲盒ID"
                  maxlength="10"
                ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="form_footer flex-rowl">
          <div class="btn" @click="query">确认</div>
          <div class="return_txt" @click="handleReturn">←返回</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCommidityDetail, editCommidity } from "../../../api/api";
export default {
  name: "cOthers",
  data() {
    return {
      loading: false,

      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        isintro: "", // 是否精品推荐商品 = 是 否
        istop: "", // 是否置顶 = 1置顶 0 不置顶
        numtype: "", // 前端购买人数<br>显示管理 = 真实购买人数 静态购买人数
        numview: "", // 前端商品已销数量静态显示设置
        ispre: "", // 是否预售
        predate: "", // 开售日期
        cmid1: "", // 关联推荐商品1的id
        cmid2: "", // 关联推荐商品2的id
        cmid3: "", // 关联推荐商品3的id
        cmid4: "", // 关联推荐商品4的id
        cmid5: "", // 关联推荐商品5的id
        cmid6: "", // 关联推荐商品6的id
        boxid1: "", // 关联盲盒id1
        boxid2: "", // 关联盲盒id2
        boxid3: "", // 关联盲盒id3
        boxid4: "", // 关联盲盒id4
        boxid5: "", // 关联盲盒id5
        boxid6: "", // 关联盲盒id6
      },
    };
  },
  created() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      let { id } = this.$route.params;
      this.loading = true;
      getCommidityDetail({ id }).then((res) => {
        this.formData.id = res.id ? res.id : "";
        this.formData.isintro = res.iisintrod ? res.isintro : "否";
        this.formData.istop = res.istop ? res.istop : 0;
        this.formData.ispre = res.ispre ? res.ispre : false;
        this.formData.predate = res.predate ? res.predate : "";
        this.formData.numtype = res.numtype ? res.numtype : "";
        this.formData.numview = res.numview ? res.numview : "";
        this.formData.cmid1 = res.cmid1 ? res.cmid1 : "";
        this.formData.cmid2 = res.cmid2 ? res.cmid2 : "";
        this.formData.cmid3 = res.cmid3 ? res.cmid3 : "";
        this.formData.cmid4 = res.cmid4 ? res.cmid4 : "";
        this.formData.cmid5 = res.cmid5 ? res.cmid5 : "";
        this.formData.cmid6 = res.cmid6 ? res.cmid6 : "";
        this.formData.boxid1 = res.boxid1 ? res.boxid1 : "";
        this.formData.boxid2 = res.boxid2 ? res.boxid2 : "";
        this.formData.boxid3 = res.boxid3 ? res.boxid3 : "";
        this.formData.boxid4 = res.boxid4 ? res.boxid4 : "";
        this.formData.boxid5 = res.boxid5 ? res.boxid5 : "";
        this.formData.boxid6 = res.boxid6 ? res.boxid6 : "";

        this.loading = false;
      });
    },
    handleClickPreOne() {
      this.formData.predate = "";
    },

    handleReturn() {
      history.back();
    },

    query() {
      let { formData } = this;
      this.loading = true;
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          // let message = this.$message.success(data.message);
          // setTimeout(() => {
          //   this.loading = false;
          //   message.close();
          //   history.back();
          // }, 1500);
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
}
</style>